<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import { useModal } from "#/composables/useModal";

const emit = defineEmits<(e: "select", type: string) => void>();

const { t } = useTranslation();
const { visible, close } = useModal("table-order-payment-type");

const selectPaymentType = (type: string) => {
	emit("select", type);
	close();
};
</script>

<template>
	<Transition name="fade">
		<div v-if="visible" class="table_order_payment_type_modal_overlay" @click.self="close">
			<div class="table_order_payment_type_modal_content">
				<div class="table_order_payment_type_container">
					<div class="content">
						<div class="title">{{ t('table-order-payment-type.title') }}</div>
						<div class="subtitle">{{ t('table-order-payment-type.subtitle') }}</div>
					</div>
				</div>

				<div class="table_order_payment_type_buttons">
					<button type="button" class="table_order_payment_type_button" @click="selectPaymentType('full')">
						{{ t('table-order-payment-type.button.pay-full') }}
					</button>

					<button type="button" class="table_order_payment_type_button" @click="selectPaymentType('partial')">
						{{ t('table-order-payment-type.button.pay-partial') }}
					</button>
				</div>
				<!-- <p class="table_order_payment_type_modal_footer">Чек придёт на указанную почту после успешной оплаты</p> -->
			</div>
		</div>
	</Transition>
</template>

<style lang="scss" scoped>
  @use './tableOrderPaymentType.scss';
</style>
